import WebService from "../WebService";
const Vote = {
  answers(params) {
    return WebService.get("/report/vote-answer?" + params);
  },
  forms(params) {
    return WebService.get("/vote/forms?" + params);
  },
  formDetail(form_id, params) {
    return WebService.get("/vote/forms/" + form_id + "?" + params);
  }
};
export default Vote;
